import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {User} from '../../../model/user/User';
import {Store} from '@ngrx/store';
import {AppState} from '../../../store/app.states';
import {LogOut} from '../../../store/actions/auth.actions';
import {fromEvent, Observable, Subscription} from 'rxjs';
import {ActivatedRoute} from '@angular/router';
import {AuthService} from '../../../services/auth.service';
import {HttpClient} from "@angular/common/http";
import {ToolbarService} from "../../../services/toolbar.service";

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.css']
})
export class ToolbarComponent implements OnInit, OnDestroy {

  @Input() user: User;
  @Input() back: boolean;
  @Input() title: string;
  @Input() destination: string;
  isMobile: boolean;
  backPage: string;

  notifications: number;
  messagesUnread: boolean;

  resizeObservable$: Observable<Event>;
  resizeSubscription$: Subscription;

  constructor(private store: Store<AppState>,
              private route: ActivatedRoute,
              private authService: AuthService,
              private httpClient: HttpClient,
              private toolbarService: ToolbarService) {
    this.toolbarService.getMessageUnreadObs().subscribe(v => this.messagesUnread = v);
    this.resizeObservable$ = fromEvent(window, 'resize');
    this.resizeSubscription$ = this.resizeObservable$.subscribe(evt => {
      if (window.innerWidth < 600) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    });

    if (window.innerWidth < 600) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }

    document.addEventListener('notification', () => {
      setTimeout(() => {
        this.notifications = 0;
        this.user = JSON.parse(localStorage.getItem('user'));
        this.user.notifications.forEach(n => {
          if (n.read === false) {
            ++this.notifications;
          }
        });
      }, 500);
    });

    document.addEventListener('update-notification', () => {
      setTimeout(() => {
        this.notifications = 0;
        this.user = JSON.parse(localStorage.getItem('user'));
        this.user.notifications.forEach(n => {
          if (n.read === false) {
            ++this.notifications;
          }
        });
      }, 500);
    });

    window.addEventListener('beforeunload', () => {
      this.authService.calcUsageTime();
    });



  }

  ngOnInit(): void {
    if (this.destination === undefined) {
      this.destination = 'landing';
    }
    this.setup();
    this.setupDestination();

    setTimeout(() => {
      const user = JSON.parse(localStorage.getItem('user'));

      if (this.user !== null && this.user !== undefined) {
        if (user.notifications !== this.user.notifications) {
          this.user = user;
          this.setup();
        }
      }
    }, 1000);
  }

  setupDestination() {
    this.route.params.subscribe(params => {
        /*if (route.includes('/:ssn/:back')) {
          this.backPage += '/' + params.ssn + '/' + params.back;
        } else if (route.includes('/:doctorID/:ssn/:type/:back')) {
          this.backPage += '/' + params.doctorID + '/' + params.ssn + '/' + params.type + '/' + params.back;
        } else if (route.includes('/:ssn/:type/:back')) {
          this.backPage += '/' + params.ssn + '/' + params.type + '/' + params.back;
        } else if (route.localeCompare(this.backPage + '/:type') === 0) {
          this.backPage += '/' + params.type;
        } else if (route.includes('/:uuid/:doctorID/:patientSSN/:back')) {
          this.backPage += '/' + params.uuid + '/' + params.doctorID + '/' + params.ssn + '/' + params.back;
        } else if (route.includes('/:uuid/:doctorID/:patientSSN')) {
          this.backPage += '/' + params.uuid + '/' + params.doctorID + '/' + params.ssn;
        }*/
      });
  }

  setup() {
    if (this.user !== null && this.user !== undefined) {
      if (this.user.notifications !== null && this.user.notifications !== undefined) {
        this.notifications = 0;
        this.user.notifications.forEach(n => {
          if (n.read === false) {
            ++this.notifications;
          }
        });
      }
      if (this.notifications === null || this.notifications === undefined) {
        this.notifications = 0;
      }

      /* Ora chiedo quanti sono gli ultimi messaggi e controllo quali di loro hanno un messaggio non
       letto che sia stato inviato da un paziente.*/
      this.toolbarService.getNumberMessagesUnread()
        .subscribe(x => {
            if(x > 0){
              this.toolbarService.updateMessageUnreadBadge(true);
            }
          }
        );
    } else {
      this.notifications = 0;
    }
  }

  logout(): void {
    this.store.dispatch(new LogOut());
  }

  ngOnDestroy() {
    this.resizeSubscription$.unsubscribe();
  }
}
